import type { AddonManagementQuoteRequestPayload } from 'models/quote/AddonQuoteRequestPayload';
import type { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

import type { QuoteResponseWithStatus } from './batchQuote';

export interface RequestAddonManagementQuoteEpicApi {
  price(request: AddonManagementQuoteRequestPayload): Observable<AddonManagementQuoteAckResponse>;
}
export interface AddonManagementQuoteAckResponse {
  quotes: QuoteResponseWithStatus[];
}

export function addonManagementQuoteRequestApi(http: IHttpClient): RequestAddonManagementQuoteEpicApi {
  return {
    price(payload) {
      return http
        .postJSON<AddonManagementQuoteAckResponse>({ url: 'api/v1/addon-management/quote', body: payload })
        .pipe(map(r => r.payload));
    },
  };
}
